import useDevTools from '../hooks/useDevTools';
import styles from './MainMenu.module.scss';
import engineSvg from './assets/engine.svg';
import logsSvg from './assets/logs.svg';
import paletteSvg from './assets/palette.svg';
import presetsSvg from './assets/presets.svg';
import propertiesSvg from './assets/properties.svg';
import React, { useMemo } from 'react';

const icons = {
  configuration: engineSvg,
  presets: presetsSvg,
  palette: paletteSvg,
  appProperties: propertiesSvg,
  logs: logsSvg,
};

const menuItems = ['configuration', 'presets', 'palette', 'appProperties', 'logs'];

const ITEM_WIDTH = 40;

const MainMenu = () => {
  const { menu, setMenu } = useDevTools();

  const position = useMemo(() => {
    return menuItems.indexOf(menu[0].id);
  }, [menu]);

  return (
    <div className={styles.menu}>
      <ul>
        {menuItems.map((id) => {
          return (
            <li>
              <button
                onClick={() => {
                  setMenu(0, id);
                }}
              >
                <img src={icons[id]} alt={id} />
              </button>
            </li>
          );
        })}
      </ul>

      <div
        className={styles.indicator}
        style={{
          transform: `translateX(${position * ITEM_WIDTH}px)`,
        }}
      />
    </div>
  );
};

export default MainMenu;
